import {COLUMN_TYPES} from 'src/components/with-interaction-table/constants';

import {TDataType as DataType} from '@pb/kit-component-table-interactions';

import type {InteractiveColumn} from 'src/components/with-interaction-table/typedef';

export const EXISTED_USER_MESSAGE = 'Existing user associated with this email found on the platform. ' +
    'This user will be linked to the {{NAME}} account.';
export const INVALID_EMAIL_MESSAGE = 'Email address is not valid';
export const INVALID_FIRST_NAME_MESSAGE = 'First name is not valid';
export const INVALID_LAST_NAME_MESSAGE = 'Last name is not valid';
export const INVALID_CITY_MESSAGE = 'City is too long.';
export const INVALID_JOB_TITLE_MESSAGE = 'Job title is too long';

export const SELECTION_KEY = 'bulk-import-selection';

export const COLUMNS = {
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    COUNTRY: 'country',
    CONFERENCE_ACCOUNT: 'conferenceAccount',
    PRIMARY_ACCOUNT: 'primaryAccount',
    JOB_TITLE: 'jobTitle',
    CITY: 'city',
    NOTES: 'notes',
};

export const HEADERS = {
    [COLUMNS.EMAIL]: 'Email*',
    [COLUMNS.FIRST_NAME]: 'First Name*',
    [COLUMNS.LAST_NAME]: 'Last Name*',
    [COLUMNS.CONFERENCE_ACCOUNT]: 'Conference Account*',
    [COLUMNS.PRIMARY_ACCOUNT]: 'Primary Account',
    [COLUMNS.COUNTRY]: 'Country',
    [COLUMNS.JOB_TITLE]: 'Job Title',
    [COLUMNS.CITY]: 'City',
    [COLUMNS.NOTES]: 'Notes',
};

export const COLUMNS_DATA: Array<InteractiveColumn> = [
    {
        columnId: COLUMNS.EMAIL,
        fixed: true,
        defaultWidth: 400,
        minWidth: 400,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.FIRST_NAME,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.TEXT,
        columnType: COLUMN_TYPES.STRING,
    },
    {
        columnId: COLUMNS.LAST_NAME,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.TEXT,
        columnType: COLUMN_TYPES.STRING,
    },
    {
        columnId: COLUMNS.CONFERENCE_ACCOUNT,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.PRIMARY_ACCOUNT,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.COUNTRY,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.JOB_TITLE,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.TEXT,
        columnType: COLUMN_TYPES.STRING,
    },
    {
        columnId: COLUMNS.CITY,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.TEXT,
        columnType: COLUMN_TYPES.STRING,
    },
    {
        columnId: COLUMNS.NOTES,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.TEXT,
        columnType: COLUMN_TYPES.STRING,
    },
];
export const TRACKING_COLUMNS = [
    'Email',
    'First name',
    'Last name',
    'Conference account',
    'Primary account',
    'Country',
    'Job title',
    'City',
    'Notes',
];
